module.exports = __webpack_public_path__ + "static/img/indexPic3.4fb409e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/indexPic3.png
// module id = WIEh
// module chunks = 1